<template>
  <div class="como-funciona">
    <div class="container custom-container">
      <p class="como-funciona--title">
        <span class="highlight">Como funciona</span> o heliar express?
      </p>
      <div class="row">
        <div class="col-24 col-lg-8">
          <div class="como-funciona--item">
            <figure class="item--img">
              <img src="../assets/como-funciona-1.png" alt="" />
            </figure>
            <p class="item--title">
              <span class="item--numero">1.</span> Peça de onde estiver
            </p>
            <p class="item--text">
              Ficou na mão? Não se preocupe! Acesse www.heliarexpress.com.br e
              confira os preços disponíveis para a sua regitão com ajuda do
              nosso filtro de busca.
            </p>
          </div>
        </div>
        <div class="col-24 col-lg-8">
          <div class="como-funciona--item">
            <figure class="item--img">
              <img src="../assets/como-funciona-2.png" alt="" />
            </figure>
            <p class="item--title">
              <span class="item--numero">2.</span> Escolha a melhor bateria
            </p>
            <p class="item--text">
              O Heliar Express te indica a melhor bateria para o seu carro!
              Escolha uma oferta, um horário e data de preferência e faça o seu
              pedido!
            </p>
          </div>
        </div>
        <div class="col-24 col-lg-8">
          <div class="como-funciona--item">
            <figure class="item--img">
              <img src="../assets/como-funciona-3.png" alt="" />
            </figure>
            <p class="item--title">
              <span class="item--numero">3.</span> Entrega rápida e segura
            </p>
            <p class="item--text">
              Agora é só esperar! Sua bateria será entregue em até 1 hora ou na
              data combinada e o pagamento só será feito na hora da entrega. A
              instalação é por nossa conta!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "comoFunciona",
};
</script>
<style lang="scss">
.como-funciona {
  color: $cinza-escuro;
  padding-bottom: 108px;
  &--title {
    text-align: center;
    font-weight: 300;
    font-style: italic;
    text-transform: uppercase;
    font-size: 29px;
    margin-bottom: 42px;
    .highlight {
      font-weight: 800;
    }
  }
  &--item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .item {
      &--img {
        margin-bottom: 20px;
        width: 225px;
        img {
          max-width: 100%;
        }
      }
      &--title {
        font-weight: 800;
        text-transform: uppercase;
        font-style: italic;
        font-size: 19px;
        margin-bottom: 12px;
        text-align: center;
        line-height: normal;
      }
      &--numero {
        color: $verde-heliar;
        display: inline-block;
        padding-right: 5px;
      }
      &--text {
        text-align: center;
        font-size: 16px;
        margin-bottom: 0;
        line-height: normal;
      }
    }
  }
}
@media(max-width: 1200px) {
  .como-funciona {
    &--title {
      font-size: 26px;
    }
    &--item {
      .item {
        &--img {
          width: 175px;
        }
        &--text {
          font-size: 14px;
        }
      }
    }
  }
}

@media(max-width: 991px) {
  .como-funciona {
    padding-bottom: 150px;
    .row {
      .col-24 {
        &:last-child {
          .como-funciona {
            &--item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    &--title {
      font-size: 46px;
      line-height: normal;
      margin-bottom: 55px;
    }
    &--item {
      width: 585px;
      margin: 0 auto 120px auto;
      .item {
        &--img {
          width: 300px;
        }
        &--title {
          font-size: 31px;
        }
        &--text {
          font-size: 27px;
        }
      }
    }
  }
}

@media(max-width: 767px) {
  .como-funciona {
    &--title {
      font-size: 30px;
    }
    &--item {
      width: 450px;
    }
  }
}

@media(max-width: 575px) {
  .como-funciona {
    &--title {
      font-size: 28px;
    }
    &--item {
      width: 280px;
      .item {
        &--img {
          width: 275px;
        }
        &--title {
          font-size: 24px;
        }
        &--text {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
